import Config from './config'

const cleanPrefix = prefix => {
  if (!prefix)
  {
    return ''
  }

  return prefix.replace(/^\/+|\/+$/g, '')
}

const joinKey = (prefix, key) => {
  let cleanKey = key.replace(/^\/+/, '')

  if (!prefix)
  {
    return cleanKey
  }

  return `${prefix}/${cleanKey}`
}

export const getDataBucket = () => {
  return Config.getConfig('dataBucket') || 'data.accounts.smartix.uk'
}

export const getTenantDataPrefix = () => {
  return cleanPrefix(Config.getConfig('tenantDataPrefix') || 'smartix.uk')
}

export const getTenantDataKey = key => {
  return joinKey(getTenantDataPrefix(), key)
}
